export const FailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M13.7507 8.25004L8.25065 13.75M8.25065 8.25004L13.7507 13.75M20.1673
       11C20.1673 16.0627 16.0633 20.1667 11.0007 20.1667C5.93804 20.1667 1.83398
        16.0627 1.83398 11C1.83398 5.93743 5.93804 1.83337 11.0007 1.83337C16.0633 1.83337 20.1673 5.93743 20.1673 11Z"
      stroke="#B91C1C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
